<template>
  <b-modal
    id="disable-enable-2fa-confirm"
    ref="modalDisableEnable"
    :title="isEnable ? 'Xác nhận BẬT LẠI xác thực 2 bước' : 'Xác nhận VÔ HIỆU xác thực 2 bước'"
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="disable-enable-2fa otp-scope">
      <p v-if="isEnable">
        Người dùng sẽ được yêu cầu <b>thiết lập lại 2FA</b> ở lần đăng nhập tiếp theo
        (phiên đăng nhập hiện tại của họ sẽ bị huỷ).
      </p>
      <p v-else>
        Sau thao tác này, người dùng sẽ <b>đăng nhập KHÔNG CẦN OTP</b>. Cân nhắc kỹ
        trước khi xác nhận.
      </p>
      <!-- Cờ AdminResetStepUpEnabled tắt -> ẩn ô OTP (BE bỏ verify). Đối xứng ModalResetOtpConfirm. -->
      <template v-if="stepUpRequired">
        <p class="mt-1">
          Nhập mã OTP hiện tại của <b>chính bạn</b> để xác nhận (bạn phải đang bật
          xác thực 2 bước).
        </p>
        <div class="mb-1 font-weight-bold">Mã xác thực của bạn</div>
        <b-form-input
          v-otp-autofocus
          ref="inputOtp"
          v-model="otp"
          type="text"
          inputmode="numeric"
          maxlength="6"
          autocomplete="one-time-code"
          pattern="[0-9]*"
          class="outline-primary input"
          placeholder="Mã OTP 6 số"
          @keyup.enter="confirm"
        />
      </template>

      <!-- Reason BAT BUOC (khác ModalResetOtpConfirm - hành động nhạy cảm hơn thì audit chặt hơn).
           maxlength 180 khớp validate BE (DisableTwoFactorModel.Reason - chừa chỗ prefix wrap). -->
      <div class="mb-1 mt-2 font-weight-bold">Lý do (BẮT BUỘC)</div>
      <b-form-textarea
        v-model="reason"
        class="outline-primary"
        placeholder="Nhập lý do (bắt buộc)"
        rows="2"
        max-rows="4"
        maxlength="180"
      />
    </div>

    <template v-slot:modal-footer>
      <div class="w-100 text-right">
        <base-button
          :button="isEnable ? 'Xác nhận bật lại' : 'Xác nhận vô hiệu'"
          :disabled="(stepUpRequired && !otp) || !reason || !reason.trim() || isLoading"
          @click="confirm"
        />
        <b-button variant="outline-primary" class="ml-1" @click="hideModal"
          >Đóng</b-button
        >
      </div>
    </template>
    <BaseLoading :is-loading="isLoading" />
  </b-modal>
</template>

<script>
import BaseLoading from "../../common/BaseLoading";
// KHONG gui deviceId khi step-up admin OTP: cùng lý do ModalResetOtpConfirm (deviceId=null -> BE
// fan-out VerifyWithActiveDevicesFallbackAsync, multi-credential admin).

// OFF 2FA per-user (Approach A - 2026-08-11): admin vô hiệu/bật lại 2FA cho user khác. STEP-UP:
// admin nhập OTP CHÍNH MÌNH -> gửi { userId (target), twoFactorCode (OTP admin), deviceId, reason }
// sang disable-2fa/enable-2fa. Reason BAT BUOC (validate FE + BE fail-closed 2 tầng).
export default {
  name: "ModalDisableEnable2Fa",
  components: { BaseLoading },
  data() {
    return {
      targetUserId: null,
      otp: null,
      reason: null,
      isLoading: false,
      // mode: 'disable' (vô hiệu 2FA - mặc định) | 'enable' (bật lại 2FA).
      mode: "disable",
      // Fail-safe: mặc định bắt step-up (nhập OTP). Cờ AdminResetStepUpEnabled=false -> false -> ẩn ô OTP.
      stepUpRequired: true,
    };
  },
  computed: {
    isEnable() {
      return this.mode === "enable";
    },
  },
  methods: {
    showModal(targetUserId, mode = "disable") {
      this.targetUserId = targetUserId;
      this.mode = mode;
      this.otp = null;
      this.reason = null;
      // 2026-09-16: đọc cờ step-up (đối xứng ModalResetOtpConfirm) -> cờ tắt thì ẩn ô OTP.
      this.stepUpRequired = true;
      this.loadStepUpFlag();
      this.$refs.modalDisableEnable.show();
    },
    // Đọc cờ SysConfig Otp.AdminResetStepUpEnabled (BE echo qua getOtpConfig). false -> bỏ bắt nhập OTP.
    // Lỗi/không đọc được -> GIỮ stepUpRequired=true (fail-safe: thà bắt nhập OTP còn hơn bỏ nhầm).
    loadStepUpFlag() {
      this.$store
        .dispatch("common/getOtpConfig")
        .then((res) => {
          if (res && res.succeeded && res.data && res.data.adminResetStepUpEnabled === false) {
            this.stepUpRequired = false;
          }
        })
        .catch(() => {
          // giữ stepUpRequired=true (fail-safe)
        });
    },
    hideModal() {
      this.otp = null;
      this.reason = null;
      this.mode = "disable";
      this.$refs.modalDisableEnable.hide();
    },
    confirm() {
      if (!this.reason || !this.reason.trim()) return;
      this.isLoading = true;
      const action = this.isEnable ? "common/enable2Fa" : "common/disable2Fa";
      this.$store
        .dispatch(action, {
          userId: this.targetUserId,
          // Cờ tắt step-up -> gửi null (BE bỏ verify). Cờ bật -> gửi OTP admin nhập. Đối xứng ModalResetOtpConfirm.
          twoFactorCode: this.stepUpRequired ? this.otp : null,
          // deviceId: null -> BE fan-out verify voi tat ca Device Active cua admin (WebAuthn multi-cred).
          deviceId: null,
          reason: this.reason.trim(),
        })
        .then((res) => {
          this.isLoading = false;
          if (res && res.succeeded) {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: this.isEnable
                ? "Đã bật lại 2FA cho người dùng"
                : "Đã vô hiệu 2FA - người dùng có thể đăng nhập không cần OTP",
            });
            this.$emit("done");
            this.hideModal();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$toasted.global.showErrorMessage({
            message:
              (error && error.data && error.data.message) ||
              "Thao tác thất bại, vui lòng kiểm tra mã xác thực và lý do.",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// Reskin OTP (Phase 4): overlay token. Giữ hợp đồng showModal(targetUserId,mode) + emit done.
// Reason bắt buộc + deviceId:null (đã shipped, KHÔNG đụng script).
.disable-enable-2fa {
  font-family: var(--otp-sans);
  font-size: 14px;
  color: var(--otp-ink);
  .input {
    border: 1px solid var(--otp-border-strong);
    border-radius: var(--otp-radius-sm);
    height: 36px;
    &:focus { border-color: var(--otp-blue); box-shadow: var(--otp-ring); outline: none; }
  }
}
</style>
